import React from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { Icon } from 'components';

export default function Unauthorized() {
  return (
    <Stack
      alignSelf="center"
      justify="center"
      alignItems="center"
      justifyContent="center"
      bg="white.default"
      borderRadius={4}
      spacing={4}
      shadow={4}
      p={6}>
      <Icon
        name="dolly-flatbed-empty"
        size="6xl"
      />
      <Text
        variant="2xLargeBold">Oops
      </Text>
      <Text variant="mediumSemiBold">A pagina que você está procurando não foi encontrada!</Text>
    </Stack>
  );
}
